// Imprimir la etiqueta propia de un bulto (el que no viene de Mercado Libre).
//
// El SVG no se abre en una pestaña nueva apuntando al endpoint: esa URL pide
// el token en la cabecera y el navegador no lo manda solo. Se trae por fetch y
// se imprime desde acá.
//
// Dos puertas para el mismo código: el vendedor imprime la etiqueta de su
// envío (`deliveries`), y el depósito la reimprime cuando el bulto llegó sin
// nada pegado (`warehouse`, que va por la capacidad warehouse_access).

import { authFetch } from "./authFetch";
import { buildPrintableHtml, labelSvgPages, openPrintWindow } from "./labelPrint";

export type PackageLabel = {
  delivery_id: number;
  code: string;
  qr_payload: string;
  receiver: string | null;
  postal_code: string | null;
  zona: string | null;
  cantidad_bultos: number;
  importe_cobranza: number | null;
  svg: string;
  svgs: string[];
  a4Cells: string[];
};

export async function fetchPackageLabel(
  deliveryId: number | string,
  { token, scope = "deliveries" }: { token: string | null; scope?: "deliveries" | "warehouse" }
): Promise<PackageLabel> {
  const path =
    scope === "warehouse"
      ? `/v2/warehouse/deliveries/${deliveryId}/label`
      : `/v2/deliveries/${deliveryId}/label`;

  const response = await authFetch(path, { token, method: "POST" });
  const json = await response.json().catch(() => ({} as any));
  if (!response.ok || json?.ok === false) {
    throw new Error(json?.error || json?.message || `Error ${response.status}`);
  }
  return json.label as PackageLabel;
}

// Siempre térmica 100x150: es la impresión "de a uno" del vendedor/depósito
// mientras arma el paquete, no el picker de formato que sí tiene la
// impresión masiva (EtiquetasImpresion.tsx). Si el envío tiene varios
// bultos (cantidad_bultos > 1), salen tantas páginas como bultos -- mismo
// lynx_code y QR en todas, solo cambia el renglón "BULTO x/N" (ver
// labelService.js). Esta función nunca marca label_printed_at (eso sigue
// siendo exclusivo de la impresión masiva, ver printLabelsBatch.ts) -- es
// un comportamiento previo que no se cambia en este trabajo.
export async function printPackageLabel(
  deliveryId: number | string,
  opts: { token: string | null; scope?: "deliveries" | "warehouse" }
): Promise<PackageLabel> {
  const label = await fetchPackageLabel(deliveryId, opts);
  const pages = labelSvgPages([label], "100x150");
  openPrintWindow(buildPrintableHtml("100x150", pages, `Etiqueta ${label.code}`), { width: 700, height: 560 });
  return label;
}
